import { NAME, ModalState } from "./constants";

const getModel = (state): ModalState => state.get(NAME);

export const isModalFormOpen = (modalFormName: string) => (state) => getModel(state).forms.includes(modalFormName);
